import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { BeneficiarioAp } from '../entities/beneficiario-ap';
import { Socket } from 'ngx-socket-io';

@Injectable({
  providedIn: 'root'
})
export class BeneficiariosService {

    constructor(private http:HttpClient,private _socket:Socket) { }

    public totalServicios(){
        return this.http.get(`${environment.api}beneficiarios/totalServicios`)
    }

    public totalServiciosBeneficiario(bendoc:number){
        return this.http.get(`${environment.api}beneficiarios/totalServicios/${bendoc}`);
    }

    public totalServiciosBeneficiarioRadicado(radicado:number){
        return this.http.get(`${environment.api}beneficiarios/totalServiciosRadicado/${radicado}`);
    }

    public async totalMeses(id_ben){
        return await this.http.get(`${environment.api}bit-contratos/getTiempoActivo/${id_ben}`).toPromise();
    }

    public beneficiarios(busqueda,campo){
        return this.http.get(`${environment.api}servicios/beneficiarios/${busqueda}/${campo}`).pipe(map((persona:Array<any>)=>{
            persona = persona.map(persona=>{
                persona.fechaIngreso = persona.fechaIngreso.replace(/T+[^\n]+/g,"");
                if(persona.fechaRetiro !== null) persona.fechaRetiro = persona.fechaRetiro.replace(/T+[^\n]+/g,"");
                if(persona.baja !== null) persona.baja = persona.baja.replace(/T+[^\n]+/g,"");
                return persona;
            });
            return persona;

        }))
    }

    usuariosDeUnBeneficiario(matricula):Observable<Array<BeneficiarioAp>>{
        return this.http.get<Array<BeneficiarioAp>>(`${environment.api}beneficiarios/${matricula}/usuarios`);
    }

    updateAp(beneficiario:BeneficiarioAp){
        return this.http.put(`${environment.api}beneficiarios/ap/${beneficiario.documento}`,beneficiario);
    }

    nuevoApBySocket(beneficiario:BeneficiarioAp){
        this._socket.emit('new beneficiario AP',{
            beneficiario,
            opeador:JSON.parse(localStorage.usuario).id_usuario
        })
    }

    nuevoServicioBySocket(beneficiario:BeneficiarioAp){
        this._socket.emit('new beneficiario AP',{
            beneficiario,
            opeador:JSON.parse(localStorage.usuario).id_usuario
        })
    }
}
